const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2023 - 2024",
    title: "Thinkful Software Engineering Bootcamp",
    desc: "Acquired comprehensive knowledge of industry best practices and software development standards, focusing on JavaScript, HTML5, CSS3, React Native, Node.js, PostgreSQL, RESTful APIs, algorithms, and data structures.",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2021-2022",
    title: "University of California, Riverside",
    desc: "Master's Degree, M.Ed.",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2018-2021",
    title: "University of California, Riverside",
    desc: "B.A, Bachelor's in Learning and Behavioral Studies",
  },

  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "2025 - Current",
    title: "CEO & Founder | Wizard Solutions",
    desc: "Founded and operate a software development and digital solutions consultancy specializing in custom web applications, e-commerce platforms, AI integrations, and business automation for upwards of 8-10 clients per month. Develop full-stack solutions using React, TypeScript, Next.js, Node.js, Python, WordPress, WooCommerce, and PostgreSQL. Architect and maintain custom e-commerce systems, payment integrations, inventory workflows, and third-party API connections for client businesses. Design and implement AI-powered tools, chatbots, and workflow automations that reduce manual processes and improve customer engagement. Improve website performance, SEO, accessibility, and Core Web Vitals through technical optimization and modern front-end development practices. Manage client discovery, requirements gathering, project planning, implementation, deployment, and ongoing technical support. ",
  },

  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "2025 - Current",
    title: "Lead Software Engineer/Tech Lead | GetOutlier",
    desc: "Leading IT Solutions and Engineering for ballistics businesses. Utilizing Python and Django for backend development, and React for frontend interfaces. Overseeing project management, team coordination, and ensuring the delivery of high-quality software solutions tailored to inventory management, SEO improvement and web development needs.",
  },

  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - 2025",
    title: "Software Engineer - FrontEnd | ComplyAI",
    desc: "Develop and enhance web applications using TypeScript, JavaScript, React, and TailwindCSS. Focus on creating intuitive, user-friendly interfaces that improve the overall user experience.Build efficient, accessible, and responsive web applications optimized for performance.Implement modern front-end development practices, ensuring clean, maintainable code.Collaborate closely with cross-functional teams to deliver high-quality solutions that address real-world problems.Continuously seek ways to improve the user experience and technical quality of web applications.",
  },
];

export default Data;
